import API, { baseURL } from "./api";
import { getSucursalInfo } from "./auth";

// Trilha de Auditoria — sge_infantil_core's routes/auditing.js (GET /api/auditing),
// the same endpoint sge_infantil_web's old auditing page used. Required by the
// backend: sucursalId, dateFrom, dateTo. Optional: operation, userName, limit.
export async function listAuditTrail({ dateFrom, dateTo, operation, userName, limit } = {}) {
  const sucursalId = getSucursalInfo()?.id;
  return API.get(`${baseURL}api/auditing`, {
    params: {
      sucursalId,
      dateFrom,
      dateTo,
      operation: operation || undefined,
      userName: userName || undefined,
      limit: limit || 500,
    },
  });
}
